import { render } from "./ThemePaletteConfiguration.vue.js?vue&type=template&id=ff50a674&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePaletteConfiguration.vue?vue&type=template&id=ff50a674&scoped=true"
import script from "./ThemePaletteConfiguration.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePaletteConfiguration.vue?vue&type=script&lang=js"
export * from "./ThemePaletteConfiguration.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePaletteConfiguration.vue?vue&type=script&lang=js"

import "./ThemePaletteConfiguration.vue.scss?vue&type=style&index=0&id=ff50a674&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePaletteConfiguration.vue?vue&type=style&index=0&id=ff50a674&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff50a674"],['__file',"src/Web/scripts/components/ThemePaletteConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff50a674"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff50a674', __exports__)) {
    api.reload('ff50a674', __exports__)
  }
  
  module.hot.accept("./ThemePaletteConfiguration.vue.js?vue&type=template&id=ff50a674&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePaletteConfiguration.vue?vue&type=template&id=ff50a674&scoped=true", () => {
    api.rerender('ff50a674', render)
  })

}


export default __exports__